// 计提等一些通用操作 todo（根据情况，可以对外暴露多个func,而不是提供class）
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { Assert } from '@/utils/validate'
import {
  jobClosingAccountFunc, jobProvisionedFunc,
  jobVerifyByRange
} from '@/api/clearing/financeManage'
import { cacheName, cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { Job } from '@/class/model/booking/Job'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import $store from '@/store'

export default class AbstractClosingAccount extends AbstractViewManage {
  /**
   * 是否审核连小票一起审核
   */
  _allSubmitFcl=false
  /**
   * 费用审核
   */
  _isChargeSubmitDirect=false

  _openSapConfig=false

  _useCheckRule=false

  _cABtnGroupView=null
  constructor(view) {
    super(view)
    this._job = null
    this.chargeCountGroup = { dataProvider: [], selectedCount: 0, showCurrency: false } // 详情合计
    this.totalProfits = [] //
    this.dataProvider = [] //
    this.allDataProvider = [] //
    this.showSelectionCount = false // 显示 选中的数量
    this.showChargeCount = true
    this.allChargeSummary = [] // 合计费用摘要
    this.needCalcAfterLoadTotalProfit = false // 需要在 利润加载完后，刷新合计利润数据
    this.selectionUuids = null

    this.isCommittedAllowAddCost = false
  }

  get cABtnGroupView() {
    return this._cABtnGroupView
  }

  set cABtnGroupView(value) {
    this._cABtnGroupView = value
  }

  get job() {
    return this._job
  }

  set job(value) {
    this._job = value
  }

  get view() {
    return this._view
  }

  set view(value) {
    this._view = value
  }

  beforeMount() {
    cache.load(cacheName.CONFIG).then(() => {
      this.allSubmitFcl = Boolean(cache.config.get('AllSubmitFcl'))
      this.isChargeSubmitDirect = Number(cache.config.get('ChargeSubmitDirect')) === 1
      this.isCommittedAllowAddCost = parseInt(cache.config.get('IsCommittedAllowAddCost')) === 1
      this.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
      this.useCheckRule = parseInt(cache.config.get('useCheckRule')) === 1
    })
  }

  /**
   * 创建完的回调钩子，尽量不要放置异步代码-避免使用不当出现问题
   */
  created() {

  }
  get openSapConfig() {
    return this._openSapConfig
  }

  set openSapConfig(value) {
    this._openSapConfig = value
  }

  get useCheckRule() {
    return this._useCheckRule
  }

  set useCheckRule(value) {
    this._useCheckRule = value
  }

  get isChargeSubmitDirect() {
    return this._isChargeSubmitDirect
  }

  set isChargeSubmitDirect(value) {
    this._isChargeSubmitDirect = value
  }

  get isCommittedAllowAddCost() {
    return this._isCommittedAllowAddCost
  }

  set isCommittedAllowAddCost(value) {
    this._isCommittedAllowAddCost = value
  }

  get allSubmitFcl() {
    return this._allSubmitFcl
  }

  set allSubmitFcl(value) {
    this._allSubmitFcl = value
  }

  async initCache() {
    await cache.load(cacheName.CONFIG)
    this.allSubmitFcl = Boolean(cache.config.get('AllSubmitFcl'))
    this.isChargeSubmitDirect = Number(cache.config.get('ChargeSubmitDirect')) === 1
    this.isCommittedAllowAddCost = parseInt(cache.config.get('IsCommittedAllowAddCost')) === 1
    this.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
    this.useCheckRule = parseInt(cache.config.get('useCheckRule')) === 1
  }

  // 核对审核日期
  async checkAccountDate(accountDate) {
    // 交给子类实现
  }

  /**
   * 改单审核提交回调
   * @param jobKeys
   * @param accountingDate
   * @returns {Promise<void>}
   */
  async batchCheckChangeConfirmCB(jobKeys, accountingDate) {
    await this.checkAccountDate(accountingDate)

    await Job.updateChangeState(jobKeys, { changeState: SystemConstants.CHANGE_AUDIT.code, branchId: this.$store.getters.currentOfficeId, accountingDate, location: this._view.location }).then(res => {
      // CARGO-697，取消审核：不可改单、改单审核
      this.$message.success(this.view.$t('Clearing.ChangeOrderApprovalSuccess'))
      this.cABtnGroupView.refresh()
    }).catch(() => {
      // todo
    }).finally(() => {
      this.cABtnGroupView.showChangeDialog = false
    })
  }
  async batchAuditConfirmCB(jobKeys, accountDate, poNo, invoiceDateSql) {
    this.cABtnGroupView.adjustPageDate = new Date(accountDate)
    await this.checkAccountDate(accountDate)
    const operateNameCode = SystemConstants.OPERATE_BATCH_AUDIT.code
    this.loading()
    await jobClosingAccountFunc({ operateNameCode, jobKeys, accountingDate: accountDate, allSubmitFcl: this.allSubmitFcl, poNo, invoiceDateSql, location: this._view.location }).then(res => {
      this.updateDefaultMenuState('manage')
      this.batchAuditConfirmSuccessCB()
    }).catch(() => {
      this.batchAuditConfirmFailCB()
    }).finally(() => {
      this.closeLoading()
      this.cABtnGroupView.showCheckDialog = false
    })
  }
  async cancelAdjustDate(pageDate) {
    this.cABtnGroupView.adjustPageDate = new Date(pageDate)
  }
  async batchAuditConfirmSuccessCB() {

  }

  async batchAuditConfirmFailCB() {

  }
  updateResultProvisioned(state) {
    // todo 如果详情页 -》 refresh（）-》逻辑较多
    // todo 如果列表页 -》重新按照查询条件进行查询
    // 列表刷新
    const jobList = getGridSelected(this._view.gridOptions)
    for (const job of jobList) {
      if (state === 1) {
        if (!job.provisioned) {
          job.provisioned = true
        }
      } else {
        if (job.provisioned) {
          job.provisioned = false
        }
      }
      this._view.gridOptions.api.refreshCells({ force: true })
    }
  }

  refresh() {
    // 交给子类实现
  }
  // 计提
  async provisionedClickHandler() {
    const list = getGridSelected(this._view.gridOptions)
    await this.updateProvisionedStateClickHandler(list, 1)
    this.cABtnGroupView.showProvisionedDialog = true
  }
  /**
   * 更新计提状态
   * @param state 0 取消，1计提
   * @returns {Promise<void>}
   */
  async updateProvisionedStateClickHandler(jobs, state) {
    await Assert.isTrue(jobs.length > 0, `${this.view.$t('Clearing.PleaseSelect')}${state === 1 ? '' : this.view.$t('Clearing.Cancel')}${this.view.$t('Clearing.ProvisionalBusinesses')}`, 'warning')
    for (const job of jobs) {
      if (state === 1) {
        await Assert.isTrue(!job.provisioned && (state === 1 || state === 4), job.jobNo + this.view.$t('Clearing.ThisIsNotForProvision'), 'warning')
      } else {
        await Assert.isTrue(job.provisioned && state === 0, job.jobNo + this.view.$t('Clearing.ForPleaseChooseProvisionedBusiness'), 'warning')
      }
    }
  }

  async updateProvisionedConfirmCB(jobKeys, provisionedDate, clearingDateSql, location) {
    await jobProvisionedFunc(jobKeys, { branchId: $store.getters.currentOfficeId, provisionedDate, clearingDateSql, location }).then(res => {
      this.$message.success(this.view.$t('FinanceManage.AccrualSucceeded'))
      this.updateResultProvisioned(1)
    }).catch(err => {
      this.failureHandler(err)
    })
  }

  /**
   * 计提弹框确认回调
   * @param provisionedDate
   * @returns {Promise<void>}
   */
  async provisionedConfirmCB(provisionedDate) {
    const jobKeys = await getGridSelectedIds(this._view.gridOptions, 'uuid')
    const selectedRows = this._view.gridOptions.api.getSelectedRows()
    let clearingDateSql = ''
    for (const d of selectedRows) {
      clearingDateSql = d.clearingDateSql
    }
    await this.updateProvisionedConfirmCB(jobKeys, provisionedDate, clearingDateSql, this._view.location)
    this.cABtnGroupView.showProvisionedDialog = false
  }

  async lockJobsClickHandler() {
    // 锁单
    this.cABtnGroupView.showLockOrderDialog = true
  }

  lockOrderConfirmCB(formData) {
    this.loading()
    jobVerifyByRange({ ...formData, branchId: this.$store.getters.currentOfficeId }).then(res => {
      this.$message.success(this.view.$t('FinanceManage.lockBusinessSuccess'))
      this.cABtnGroupView.showLockOrderDialog = false
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }

  failureHandler(err) {
    this.$message(this.view.$t('Clearing.FrontEndErrorCallbackFailed') + err)
  }

  initializeHandler() {
    cache.load(cacheName.CONFIG)
    this._view.userJobByRole = this.$checkPermission(['role_ACPayAuth_userJob'])
  }

  getUserDepartmentTeamHandler(results) {
    if (results) {
      this._view.departmentTeamUser = results
    }
    // 查询同组人业务
    if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
      this.queryDataRole()
    }
  }
  /**
   * 同组或个人查询
   */
  queryDataRole(isDepartment = true, queryMasterDb = false) {
    const roleMap = this.getRoleByOpUsers(isDepartment)
    const roleOp = roleMap['roleOp']
    const roleSales = roleMap['roleSales']
    if (AdvancedSearchOption.hasField('job.op_id', this._view.searchConditions.snapshotConditions)) {
      AdvancedSearchOption.removeOption('job.op_id', this._view.searchConditions.snapshotConditions)
    }
    if (AdvancedSearchOption.hasField('job.sales_id', this._view.searchConditions.snapshotConditions)) {
      AdvancedSearchOption.removeOption('job.sales_id', this._view.searchConditions.snapshotConditions)
    }
    this.toQueryListWithProfitAndList({ 'roleOp': roleOp, 'roleSales': roleSales }, queryMasterDb)
  }
  /**
   * 查询操作
   */
  getRoleByOpUsers(isDepartment) {
    const role = {}
    const roleOp = []
    const roleSales = []
    const currentUserId = this._view.$store.getters.userId
    const $conditions = this._view.searchConditions.snapshotConditions
    if (AdvancedSearchOption.hasField('job.op_id', $conditions) && AdvancedSearchOption.hasField('job.sales_id', $conditions)) {
      const searchOp = AdvancedSearchOption.getOption('job.op_id', $conditions)
      const searchOpEqualOperation = searchOp.operator === '=' // 【等于】条件
      const searchSales = AdvancedSearchOption.getOption('job.sales_id', $conditions)
      const searchSalesEqualOperation = searchSales.operator === '=' // 【等于】条件
      if (!isDepartment) {
        if (searchOpEqualOperation ? Number(searchOp.value) === currentUserId : Number(searchOp.value) !== currentUserId) {
          roleOp.push(currentUserId)
        } else {
          roleOp.push(-1)
        }
        if (searchSalesEqualOperation ? Number(searchSales.value) === currentUserId : Number(searchSales.value) !== currentUserId) {
          roleSales.push(currentUserId)
        } else {
          roleSales.push(-1)
        }
      } else {
        if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
          if (searchOpEqualOperation) {
            if (this._view.departmentTeamUser.includes(searchOp.value)) {
              roleOp.push(searchOp.value)
            } else {
              if (Number(searchOp.value) === currentUserId) {
                roleOp.push(currentUserId)
              } else {
                roleOp.push(-1)
              }
            }
            if (this._view.departmentTeamUser.includes(searchSales.value)) {
              roleSales.push(searchSales.value)
            } else {
              if (Number(searchSales.value) === currentUserId) {
                roleSales.push(currentUserId)
              } else {
                roleSales.push(-1)
              }
            }
          } else {
            roleOp.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchOp.value
            }))
            roleSales.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchSales.value
            }))
          }
        }
      }
    } else if (AdvancedSearchOption.hasField('job.op_id', $conditions) && !AdvancedSearchOption.hasField('job.sales_id', $conditions)) {
      const searchOp1 = AdvancedSearchOption.getOption('job.op_id', $conditions)
      const searchOpEqualOperation = searchOp1.operator === '=' // 【等于】条件
      if (!isDepartment) {
        if (searchOpEqualOperation ? Number(searchOp1.value) === currentUserId : Number(searchOp1.value) !== currentUserId) {
          roleOp.push(currentUserId)
        } else {
          roleOp.push(-1)
        }
      } else {
        if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
          if (searchOpEqualOperation) {
            if (this._view.departmentTeamUser.includes(searchOp1.value)) {
              roleOp.push(searchOp1.value)
            } else {
              if (Number(searchOp1.value) === currentUserId) {
                roleOp.push(currentUserId)
              } else {
                roleOp.push(-1)
              }
            }
          } else {
            roleOp.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchOp1.value
            }))
          }
        }
      }
      roleSales.push(-1)
    } else if (!AdvancedSearchOption.hasField('job.op_id', $conditions) && AdvancedSearchOption.hasField('job.sales_id', $conditions)) {
      const searchSales1 = AdvancedSearchOption.getOption('job.sales_id', $conditions)
      const searchSalesEqualOperation = searchSales1.operator === '=' // 【等于】条件
      if (!isDepartment) {
        if (searchSalesEqualOperation ? Number(searchSales1.value) === currentUserId : Number(searchSales1.value) !== currentUserId) {
          roleSales.push(currentUserId)
        } else {
          roleSales.push(-1)
        }
      } else {
        if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
          if (searchSalesEqualOperation) {
            if (this._view.departmentTeamUser.includes(searchSales1.value)) {
              roleSales.push(searchSales1.value)
            } else {
              if (Number(searchSales1.value) === currentUserId) {
                roleSales.push(currentUserId)
              } else {
                roleSales.push(-1)
              }
            }
          } else {
            roleSales.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchSales1.value
            }))
          }
        }
      }
      roleOp.push(-1)
    } else {
      if (!isDepartment || this._view.departmentTeamUser === null || this._view.departmentTeamUser.length === 0) {
        roleOp.push(currentUserId)
        roleSales.push(currentUserId)
      } else {
        roleOp.push(...this._view.departmentTeamUser)
        roleSales.push(...this._view.departmentTeamUser)
      }
    }
    role.roleOp = roleOp
    role.roleSales = roleSales
    return role
  }

  /**
   * 修改状态-按钮可操作性的状态
   */
  updateDefaultMenuState() {

  }

  clearBottomTotalData() {
    this.totalProfits = []
  }

  resultHandler(wapper) {
    this.selectionUuids = null
    if (!this.totalProfits || !this.totalProfits.length) {
      this.needCalcAfterLoadTotalProfit = true
    }
    if (!this._view.searchExportExcel) {
      ClearingUtils.mergeVoucherResult(wapper)
      ChargeUtils.calcIsVerification(wapper)
      this.allDataProvider = wapper.results.list
      this.allChargeSummary = wapper.chargeSummary || []
    }
    this.refreshSelectedCount()
  }
  /**
   * 选择主票时去除其小票
   */
  filterConflictSlaves(jobs = []) {
    const jobUuids = jobs.map(job => job.uuid)
    return jobs.filter(job => {
      return !(job.lclMasterUuid && jobUuids.includes(job.lclMasterUuid))
    })
  }
  // 右下角统计
  refreshSelectedCount(needLoading = true) {
    this._view.selectionCountLabel = ''
    if (needLoading) {
      this.loading()
    }
    let selections = getGridSelected(this._view.gridOptions)
    const length = selections.length
    selections = this.filterConflictSlaves(selections)
    const currentSelectionsUuids = selections.map(item => item.uuid)

    console.log('selections.length', selections.length)
    if (this._view.showSelectionCount && length > 0) {
      this._view.selectionCountLabel = this._view.$t('CargoMsg.Cargo_Select') + ' ' + length + ':'
    }
    this.selectionUuids = currentSelectionsUuids
    if (length > 0) {
      // 选中数据
      this.totalProfits = selections
    } else if (this._view.showTotalProfit) {
      this.totalProfits = this.filterConflictSlaves(this.allDataProvider)
      this.dataProvider = this.filterConflictSlaves(this.allDataProvider)
    } else {
      // 当前页显示数据
      const dataShowList = []
      this._view.gridOptions.api.forEachNode((node, index) => {
        if (node.displayed) {
          dataShowList.push(node.data)
        }
      })
      this.totalProfits = dataShowList
    }
    // 刷新右下角统计
    if (this.chargeCountGroup && this.showChargeCount) {
      // 合计详情数据处理
      this.chargeCountGroup.dataProvider = []
      let list = []
      if (length > 0) {
        // 选中数据
        list = selections.map(item => item.uuid)
        this.chargeCountGroup.selectedCount = length
      } else if (this._view.showTotalProfit) {
        // 当前页数据
        list = this._view.rowData.map(item => item.uuid)
        this.chargeCountGroup.selectedCount = 0
      } else {
        // 当前页显示数据
        const dataShowList = []
        this._view.gridOptions.api.forEachNode((node, index) => {
          if (node.displayed) {
            dataShowList.push(node.data.uuid)
          }
        })
        list = dataShowList
        this.chargeCountGroup.selectedCount = 0
      }
      this.chargeCountGroup.showCurrency = true
      if (list.length > 0) {
        this.chargeCountGroup.dataProvider = this.allChargeSummary.filter(item => {
          return (list.includes(item.jobUUid))
        })
      }
    }
    if (needLoading) {
      this.closeLoading()
    }
  }
  //
  queryFieldSuccess(list) {
    if (list.length > 0) {
      this.chargeCountGroup.dataProvider = list
      console.log('this.chargeCountGroup.dataProvider', this.chargeCountGroup.dataProvider)
    }
  }
}
